import React from 'react';

export const ButtonNext = ({ onClick, disabled, children }) => {
  return (
    <button className="btn-orange-normal" disabled={disabled} onClick={onClick}>{children}</button>
  )
}